import { useState } from 'react'

const useSearchForm = (initialValues, callback) => {
  const [inputs, setInputs] = useState(initialValues)

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault()
    }
    callback()
  }

  const handleInputChange = (event) => { 
    console.log('SearchFormHook.handleInputChange', event)

    let newValues
    if (event.target) {
      if (event.target.name === 'inputValue') {
        // multi-select
        if (event.selectedValues) {
          newValues = event.selectedValues
        } else {
          newValues = []
          // don't add an array value for empty string
          if (event.target.value) {
            newValues[0] = event.target.value
          }
        }
      } else {
        newValues = event.target.value
      }
      // multi-selects will set event.index, all others use the attribute value for "index"
      const index = event.hasOwnProperty('index') ? event.index : event.target.getAttribute('index')
      console.log(`index: ${index}, name: ${event.target.name}`)
      inputs[index][event.target.name] = newValues
      setInputs(inputs)
    }
    console.log(inputs)
  }

  return {
    handleSubmit,
    handleInputChange,
    inputs
  }
}

export default useSearchForm